<template>
  <div>
    <ValidationProvider
      :name="$t('change_detail_license_plates')"
      rules="required"
      v-slot="{ errors }"
    >
      <v-combobox
        v-model="licensePlateList"
        :items="allLicensePlateList"
        :disabled="isAllTextFieldDisable"
        :loading-text="$t('common_get_data')"
        :no-data-text="$t('common_no_data')"
        :loading="isLoadingLicensePlate"
        @change="setLicensePlate"
        :error-messages="errors[0]"
        small-chips
        multiple
      >
        <template v-slot:label>
          <span class="red--text">
            <strong>* </strong>
          </span>
          {{ $t('change_detail_license_plates') }}
        </template>
        <template v-slot:append-outer>
          <LicensePlateBatchInputButton
            :value="licensePlateList"
            :disabled="isAllTextFieldDisable"
            @input="onBatchInput"
          />
        </template>
      </v-combobox>
    </ValidationProvider>
  </div>
</template>

<script>
import { HttpCustomerLicensePlateMapping } from '@/js/http-Manager'
import LicensePlateBatchInputButton from '@/components/ChangeDetail/LicensePlateBatchInputButton.vue'

export default {
  name: 'LicensePlateComboboxByCustomerId',
  components: {
    LicensePlateBatchInputButton
  },
  props: {
    customerId: {
      type: String
    },
    fatherLicensePlateList: {
      type: Array
    },
    isAllTextFieldDisable: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    allLicensePlate: [],
    searchCount: 0,
    isLoadingLicensePlate: false,
    licensePlateList: []
  }),
  computed: {
    allLicensePlateList () {
      return this.allLicensePlate.map((item) => item.LicensePlate)
    }
  },
  async mounted () {
    await this.getLicensePlate()
    this.licensePlateList = JSON.parse(JSON.stringify(this.fatherLicensePlateList))
  },
  watch: {
    async fatherLicensePlateList (val) {
      this.licensePlateList = JSON.parse(JSON.stringify(val))
    },
    async customerId () {
      this.$emit('setLicensePlate', [])
      await this.getLicensePlate()
    }
  },
  methods: {
    setLicensePlate () {
      this.$emit('setLicensePlate', this.licensePlateList)
    },
    onBatchInput (newList) {
      this.licensePlateList = newList
      this.setLicensePlate()
    },
    async getLicensePlate () {
      if (this.customerId) {
        this.isLoadingLicensePlate = true
        let param = {
          customerId: this.customerId
        }
        let response = await HttpCustomerLicensePlateMapping.GetLicensePlateListByCustomerId(param)
        this.allLicensePlate = response && response.status === 200 ? response.data.Data : []
        this.isLoadingLicensePlate = false
      } else {
        this.allLicensePlate = []
      }
    }
  }
}
</script>
